import dom from '../utils/dom';
import { loadModal } from '../AsyncLoader';
import Service from './AddressVerificationService';
import ContentStorage, { ComponentKeys } from '../tnew/content/ContentStorage';

/** @typedef {import("./types").Address} Address */
/** @typedef {import('../tnew/ui/Modal/FormModalHandle').default} FormModalHandle */


const RadioOption = {
  USE_SELECTED: 'useSelected',
  USE_AS_ENTERED: 'useAsEntered',
  ALLOW_EDIT: 'allowEdit',
};


function getAvsComponentData() {
  const key = ComponentKeys.ADDRESS_VERIFICATION_SERVICE;

  return {
    subhead: ContentStorage.get(key, 'Subhead'),
    subheadText: ContentStorage.get(key, 'SubheadText'),
    useSelectedAddressLabel: ContentStorage.get(key, 'UseSelectedAddressLabel'),
    useEnteredAddressLabel: ContentStorage.get(key, 'UseEnteredAddressLabel'),
    useEditedAddressLabel: ContentStorage.get(key, 'UseEditedAddressLabel'),
    submitButtonLabel: ContentStorage.get(key, 'SubmitButtonLabel'),
  };
}


/**
 * @param {Array} options
 */
function buildSuggestionsElement(options) {
  if (options.length === 1) {
    const $div = document.createElement('div');
    $div.setAttribute('class', 'alert alert-info');
    $div.textContent = options[0].PartialAddress;

    return $div;
  }
  const $select = document.createElement('select');
  $select.classList.add('form-control');
  $select.setAttribute('aria-label', 'Suggested Addresses');

  options.forEach((value) => {
    const $option = document.createElement('option');
    $option.textContent = value.PartialAddress;
    $option.value = value.Id;
    $select.appendChild($option);
  });

  return $select;
}


class SuggestedAddressesSelectionResponse {
  /**
   * @param {Address} confirmedAddress
   * @param {FormModalHandle} modal
   * @param {boolean} wasCancelled
   */
  constructor(confirmedAddress, modal, wasCancelled) {
    this.confirmedAddress = confirmedAddress;
    this.modal = modal;
    this.wasCancelled = wasCancelled;
  }
}


/**
 * @param {array} suggestedAddresses
 * @param {Address} userEnteredAddress
 * @returns {Promise<SuggestedAddressesSelectionResponse>}
 */
async function getSuggestedAddressesSelection(suggestedAddresses, userEnteredAddress) {
  const Modal = await loadModal();

  const {
    submitButtonLabel,
    subhead,
    subheadText,
    useSelectedAddressLabel,
    useEnteredAddressLabel,
    useEditedAddressLabel,
  } = getAvsComponentData();

  const OPTION_NAME = 'tn-address-verification-option';
  const SUGGESTIONS_CONTAINER_CLASS = 'tn-address-verification-form__suggested-addresss-container';

  const $form = dom.parseElement(`
    <form id="tn-address-verification-form">
      <fieldset>
        <div class="tn-address-verification-form__subhead">${subheadText}</div>
        <ul class="tn-address-verification-form__option-list">
          <li class="tn-address-verification-form__option-list-item">
            <div class="radio">
              <label><input type="radio" name="${OPTION_NAME}" value="${RadioOption.USE_SELECTED}" checked="checked">${useSelectedAddressLabel}</label>
              <div class="${SUGGESTIONS_CONTAINER_CLASS}"></div>
            </div>
          </li>
          <li class="tn-address-verification-form__option-list-item">
            <div class="radio">
              <label><input type="radio" name="${OPTION_NAME}" value="${RadioOption.USE_AS_ENTERED}">${useEnteredAddressLabel}</label>
            </div>
          </li>
          <li class="tn-address-verification-form__option-list-item">
            <div class="radio">
              <label><input type="radio" name="${OPTION_NAME}" value="${RadioOption.ALLOW_EDIT}">${useEditedAddressLabel}</label>
            </div>
          </li>
        </ul>
      </fieldset>
    </form>
  `);

  const $radios = dom.findAllFrom($form, `input[name="${OPTION_NAME}"]`);
  const $suggestions = buildSuggestionsElement(suggestedAddresses);

  dom.findFrom($form, `.${SUGGESTIONS_CONTAINER_CLASS}`).appendChild($suggestions);

  return new Promise((resolve) => {
    const onSubmit = async (modal) => {
      /** @type {Address} */
      let confirmedAddress = null;

      const selectedOption = $radios.find($el => $el.checked).value;

      if (selectedOption === RadioOption.USE_SELECTED) {
        let addressData;

        if (suggestedAddresses.length === 1) {
          addressData = suggestedAddresses[0];
        } else {
          const selectedAddressId = $suggestions.value;

          addressData = suggestedAddresses.find(el => el.Id === selectedAddressId);
        }

        confirmedAddress = await Service.getAddress(addressData.requestedCountryValue, addressData.Id);
      } else if (selectedOption === RadioOption.USE_AS_ENTERED) {
        confirmedAddress = userEnteredAddress;
      }

      const wasCancelled = confirmedAddress === null;

      resolve(new SuggestedAddressesSelectionResponse(confirmedAddress, modal, wasCancelled));
    };

    Modal.presentForm({
      title: subhead,
      labelBtnSubmit: submitButtonLabel,
      labelBtnCancel: null,
      $form,
      onSubmit,
      closeOnEscape: false,
      closeOnBackdrop: false,
      closeButtonInHeader: false,
    });
  });
}


export default getSuggestedAddressesSelection;



// WEBPACK FOOTER //
// ./V7/addressVerification/getSuggestedAddressesSelection.js